// target is a DOM element (anything under .nav-item)
// clazz: online, paper, arena
function updateDropdownTypeToggle(target, clazz, clazzLabelText) {
  var navItem = target.closest(".nav-item");
  if (!navItem) return;
  navItem.querySelectorAll(".nav-link").forEach(function(el) {
    el.textContent = clazzLabelText;
    el.classList.remove("paper", "arena", "online");
    el.classList.add(clazz);
  });
}
window.updateDropdownTypeToggle = updateDropdownTypeToggle;
